<ngx-intl-tel-input
  [cssClass]="'w-100 tel-input-v2 ui-input'"
  [enableAutoCountrySelect]="true"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
  [selectFirstCountry]="false"
  [selectedCountryISO]="CountryISO.UnitedStates"
  [maxLength]="15"
  [phoneValidation]="true"
  [separateDialCode]="separateDialCode"
  [numberFormat]="PhoneNumberFormat.National"
  name="phone"
  [required]="required()"
  [formControl]="control"
>
</ngx-intl-tel-input>

<ui-bottom-sheet
  [open]="sheetOpen()"
  [title]="'PHONE_INPUT.SELECT_COUNTRY' | translate"
  [stableHeight]="true"
  (closeEmit)="closeCountrySheet()"
>
  <div sheet-content>
    <div class="sheet-search-wrapper">
      <input
        class="ui-input ui-input-40 w-100"
        [formControl]="countrySearchControl"
        [placeholder]="'PHONE_INPUT.SEARCH_COUNTRY' | translate"
      />
      @if (countrySearchControl.value) {
        <span
          class="input-icon-end ui-icon-close ui-mat-icon-16"
          (click)="countrySearchControl.setValue('')"
        ></span>
      }
    </div>

    <div class="sheet-options-list">
      @for (country of filteredCountries(); track country.iso2) {
        <label class="sheet-option" (click)="onCountryTap(country)">
          <span
            class="custom-radio"
            [class.checked]="country.iso2 === selectedCountryIso()"
          >
          </span>
          <div class="iti__flag" [ngClass]="country.flagClass"></div>
          <span
            class="option-label"
            [class.selected]="country.iso2 === selectedCountryIso()"
          >
            {{ country.name }}
          </span>
          <span class="country-dial-code">+{{ country.dialCode }}</span>
        </label>
      } @empty {
        <div class="sheet-empty-state">
          {{ 'PHONE_INPUT.NO_COUNTRIES_FOUND' | translate }}
        </div>
      }
    </div>
  </div>
</ui-bottom-sheet>
